/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import Link from "next/link";
import styled from "styled-components";

import { Auth } from "src/classes/user/auth/Auth";
import { LDBlock, LDExternalLinkBlock } from "src/components/Splash/LDBlock";
import { StyledLink } from "src/components/UI/Links";
import { AppRoutes, AuthLevel } from "src/lib/constants";

export function ApplyBlock() {
  return (
    <LDExternalLinkBlock target="_blank" rel="noopener noreferrer" href={"https://airtable.com/shrlTjF1dFNoi6E6s"}>
      <H2TextWrapper>&gt;&gt; APPLY NOW</H2TextWrapper>
    </LDExternalLinkBlock>
  );
}

export const H2TextWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  font-family: IBM Plex Mono;
  font-size: 22px;
  color: inherit;
`;

interface Props {
  text: string | React.ReactNode;
  url: string;
}

export function CalloutBlock({ text, url }: Props) {
  return (
    <Link href={url} passHref>
      <LDExternalLinkBlock>
        <H2TextWrapper>{text}</H2TextWrapper>
      </LDExternalLinkBlock>
    </Link>
  );
}

export function DualCalloutBlock() {
  const auth = Auth.instance;
  const authorizationLevel = auth.observe((state) => state.authLevel);

  return (
    <LDBlock
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        marginTop: "20px",
        marginBottom: "20px",
        paddingTop: "36px",
        paddingBottom: "36px",
      }}
    >
      <Link href={AppRoutes.Register} passHref prefetch={false}>
        <StyledLink>
          <H2TextWrapper>&gt;&gt; JOIN</H2TextWrapper>
        </StyledLink>
      </Link>
      <Link
        href={authorizationLevel === AuthLevel.Authorized ? AppRoutes.HomeMine : AppRoutes.Signin}
        passHref
        prefetch={false}
      >
        <StyledLink>
          <H2TextWrapper>
            {authorizationLevel === AuthLevel.Authorized ? ">> OPEN APP" : ">> SIGN IN"}
          </H2TextWrapper>
        </StyledLink>
      </Link>
    </LDBlock>
  );
}
